module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-view"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "css": false,
      "mode": "out-in"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.showList,
      "after-enter": _vm.afterEnter,
      "leave": _vm.hideList
    }
  }, [_c('div', {
    staticClass: "list-view__content",
    class: {
      empty: _vm.items.length === 0
    }
  }, [(_vm.items.length === 0) ? _c('p', [_vm._v("\n        Deze lijst lijst is leeg. Voeg een product toe door op de plus rechts onderin te drukken.\n        " + _vm._s(_vm.getCurrentList().suggestions.length > 0 ? 'Of voeg een van de onderstaande suggesties toe' : '') + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0) ? _c('v-list', {
    ref: "list",
    class: {
      shopping: _vm.shoppingState
    },
    attrs: {
      "id": "list"
    }
  }, [_c('draggable', {
    attrs: {
      "options": {
        handle: '.draggable',
        animation: 150
      }
    },
    model: {
      value: (_vm.items),
      callback: function($$v) {
        _vm.items = $$v
      },
      expression: "items"
    }
  }, [_c('transition-group', {
    attrs: {
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.items), function(item) {
    return _c('list-item', {
      key: _vm.listID + '--' + item.id,
      attrs: {
        "item": item,
        "collected": item.collected,
        "type": "list"
      }
    })
  }), 1)], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.shoppingState && _vm.shownSuggestedItems > 0) ? _c('div', {
    staticClass: "list-view__suggestions"
  }, [(_vm.items.length !== 0) ? _c('p', [_vm._v("Suggesties voor de volgende keer dat je boodschappen haalt")]) : _vm._e(), _vm._v(" "), _c('v-list', {
    ref: "suggestions",
    attrs: {
      "id": "suggest"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "suggestions",
      "css": false
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "leave": _vm.leave
    }
  }, _vm._l((_vm.suggestedItems), function(item, index) {
    return _c('list-item', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.dontShowSuggestionIfItemAlreadyOnList(item)),
        expression: "dontShowSuggestionIfItemAlreadyOnList(item)"
      }],
      key: _vm.listID + '--' + item.id,
      attrs: {
        "data-index": index,
        "item": item,
        "type": "category"
      }
    })
  }), 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-635f9f2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/app/ShowList.vue
// module id = 489
// module chunks = 1